import React, { useEffect, useState } from 'react'
import { Button, Input, Modal, Select } from 'antd'
import { SearchOutlined, PlusOutlined, ExportOutlined, RetweetOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { SearchWrapper, WhiteWrapper } from './targeting.styled'
import MainTable from '../../components/Basic/MainTable'
import useParams from '../../hook/useParams'
import { fetchTarget } from '../../apis/target'
import { useLocation, useNavigate } from 'react-router-dom'
import SegmentTable from './Component/SegmentTable'
import { fetchExport } from '../../apis/export'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import TargetConfirmModal from './Component/ConfirmationModal'
import { fetchBrandList } from '../../apis/brand'
import { fetchGroupList } from '../../apis/group'

function Targeting (props) {
  const { viewOnly, adminMode } = props
  const { t: ln_t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { pathname } = location || {}
  const user = useSelector((state) => state.user)
  const { nowBrand, nowGroup } = user || {}
  const viewOnlyDefParams = { groupId: adminMode ? undefined : nowGroup, brandId: undefined }
  const params = useParams({ includes: 'creator,targetingDetail,targetingDetail.segment,targetingDetail.invoiceSegment,brand', brandId: nowBrand, ...viewOnly ? viewOnlyDefParams : {} })
  const { handleFetchParams, fetchParams } = params
  const segmentParams = useParams()
  const { fetchParams: segFetchParams, handleFetchParams: segHandleFetchParams } = segmentParams

  const [showSegment, setShowSegment] = useState(false)
  const [dataExport, setDataExport] = useState([])
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [retarget, setRetarget] = useState(false)
  const [brands, setBrands] = useState([])
  const [searchVal, setSearchVal] = useState()
  const [groupList, setGroupList] = useState([])

  const handleShowSegment = (e, { name }) => {
    segHandleFetchParams('add', { data: e, name })
    setShowSegment(true)
  }

  const handleRetarget = ({ targetingDetail }) => {
    setRetarget({ segments: targetingDetail?.map(i => i.segment).filter(i => i) })
    setShowConfirmModal(true)
  }

  const apiFunc = async () => fetchTarget(fetchParams)
  const formatDate = date => dayjs(date).format('DD-MM-YYYY')
  const columns = [
    { title: ln_t('util.name'), dataIndex: 'name', sorter: true },
    {
      title: ln_t('target.segmentCount'),
      dataIndex: 'targetingDetail',
      render: (e, data) => e?.length > 0 ? <div className="link-text" onClick={() => handleShowSegment(e, data)}>{e.length}</div> : 0
    },
    {
      title: ln_t('target.dataExport'),
      dataIndex: 'dataExportId',
      render: (e, data) => dataExport?.find(i => i.id === e)?.name || '-',
      filters: dataExport.map(i => ({ text: i.name, value: i.id })),
      filterMultiple: false
    },
    // {
    //   title: ln_t('target.totalQuantity'),
    //   dataIndex: 'targetingDetail',
    //   render: e => e.some(i => !Number(i.count) || i.count === 0)
    //     ? <Loading3QuartersOutlined spin />
    //     : <Statistic value={e.reduce((all, val) => all + Number(val.count), 0)} />
    // },
    { title: ln_t('util.createdAt'), dataIndex: 'createdAt', sorter: true, render: e => formatDate(e) },
    { title: ln_t('util.updatedAt'), dataIndex: 'updatedAt', sorter: true, render: e => formatDate(e) },
    {
      title: ln_t('util.action'),
      dataIndex: 'id',
      render: (id, data) => {
        const { targetingDetail: e } = data
        const disableRetarget = e.some(i => !Number(i.count) && i.count !== 0) || e.reduce((all, val) => all + Number(val.count || 0), 0) === 0
        return <div className="action-btn">
          {viewOnly ? '' : <Button size="small" icon={<RetweetOutlined />} disabled={disableRetarget} onClick={() => handleRetarget(data)}>{ln_t('target.targetAgain')}</Button>}
          <Button size="small" icon={<ExportOutlined />} onClick={() => navigate(`${pathname}/preview`, { state: { data } })}>{ln_t('target.viewDetails')}</Button>
        </div>
      }
    }
  ]

  const getDataExp = async () => {
    const res = await fetchExport({ maxResults: 999 })
    if (res?.status === 200) setDataExport(res?.data)
  }
  const getBrands = async () => {
    const res = await fetchBrandList({ maxResults: 999, groupId: nowGroup })
    if (res?.status === 200) setBrands(res?.data?.map(i => ({ value: i.id, label: i.name })))
  }
  const getGroups = async () => {
    const res = await fetchGroupList({ maxResults: 999 })
    if (res?.status === 200) setGroupList(res?.data?.map(i => ({ value: i.id, label: i.name })))
  }
  useEffect(() => { getDataExp() }, [])

  useEffect(() => {
    setSearchVal()
    handleFetchParams('init')
    if (adminMode) getGroups()
    if (viewOnly && !adminMode) getBrands()
  }, [viewOnly])

  useEffect(() => {
    const refetch = (nowBrand && nowBrand !== 0 && nowBrand !== fetchParams.brandId)
    if (refetch) handleFetchParams('add', { brandId: nowBrand })
  }, [nowBrand])

  return (
    <>
      <WhiteWrapper>
        <h3>{ln_t('sidebar.targeting')}</h3>
        <SearchWrapper>
          <Input.Search
            allowClear
            style={{ width: '400px' }}
            value={searchVal}
            placeholder={ln_t('util.search')}
            onChange={e => setSearchVal(e?.target?.value)}
            onSearch={e => handleFetchParams('add', { name: `%${e}%` })}
            enterButton={<Button type="primary" size="small" icon={<SearchOutlined />} />}
          />
          {viewOnly
            ? adminMode
              ? <div className="d-flex">
                  <div style={{ fontSize: '14px', fontWeight: 500, margin: 'auto 8px' }}>{ln_t('util.group')} :</div>
                  <Select
                    showSearch
                    style={{ minWidth: '120px' }}
                    defaultValue="all"
                    placeholder={`${ln_t('util.select')} ${ln_t('util.group')}`}
                    options={[{ value: 'all', label: 'ALL' }, ...groupList]}
                    optionFilterProp="children"
                    onChange={e => handleFetchParams('add', { groupId: e === 'all' ? undefined : e })}
                  />
                </div>
              : <div className="d-flex">
                  <div style={{ fontSize: '14px', fontWeight: 500, margin: 'auto 8px' }}>{ln_t('util.brand')} :</div>
                  <Select
                    showSearch
                    style={{ minWidth: '120px' }}
                    defaultValue=""
                    placeholder={`${ln_t('util.select')} ${ln_t('util.brand')}`}
                    options={[{ value: '', label: 'ALL' }, ...brands]}
                    optionFilterProp="children"
                    onChange={e => handleFetchParams('add', { brandId: e })}
                  />
                </div>
            : <Button type="default" icon={<PlusOutlined />} onClick={() => navigate('/targeting/new')} >
                {ln_t('util.add')} {ln_t('sidebar.targeting')}
              </Button>
          }
        </SearchWrapper>

        <MainTable
          columns={columns}
          rowKey="id"
          apiFunc={apiFunc}
          params={params}
        />
      </WhiteWrapper>

      {/* --- Segment Modal --- */}
      <Modal width={750} title={`${segFetchParams?.name || ''} ${ln_t('segment.segment')}`} open={showSegment} footer={null} onCancel={() => setShowSegment(false)}>
        <SegmentTable segmentParams={segmentParams} dataExport={dataExport} />
      </Modal>

      <TargetConfirmModal params={params} data={retarget} show={showConfirmModal} setShow={setShowConfirmModal} retarget />
    </>
  )
}

export default Targeting
